export class TeamWorkDto {
    value: number;

    playerIds: number[];

    teamId: number;
}